import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { ICodename, IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardByHospital = ({
    mode,
    dataOptions,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        byHospital: ICodename[];
        byHospitalSources: ICodename[];
    };
}) => {

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.BY_HOSPITAL}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.byHospitalSources}
                        label={Strings.ANALYSIS.SOURCE_REPORT}
                        defaultValue={dataAnalysis?.byHospitalSource}
                        errorMessage={errorAnalysis?.byHospitalSource}
                        placeholder={Strings.ANALYSIS.SELECT_SOURCE_REPORT}
                        onChange={(value) => {
                            handleChangeValue("byHospitalSource", value)
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.byHospital}
                        label={Strings.ANALYSIS.HOSPITAL_CLASS}
                        defaultValue={dataAnalysis?.byHospital}
                        errorMessage={errorAnalysis?.byHospital}
                        placeholder={Strings.ANALYSIS.SELECT_HOSPITAL_CLASS}
                        onChange={(value) => {
                            handleChangeValue("byHospital", value)
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardByHospital;
